const state = {
  pendingCalls: [],
};

const getters = {
  isActive: state => state.pendingCalls.length > 0,
};

const mutations = {
  add(state, payload) {
    state.pendingCalls.push(payload);
  },
  remove(state, payload) {
    const index = state.pendingCalls.indexOf(payload);
    if (index >= 0) {
      state.pendingCalls.splice(index, 1);
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
};
